
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/categories",
      function () {
        return require("private-next-pages/admin/categories/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/categories"])
      });
    }
  